import {
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  MenuItem,
  Typography,
  Button,
} from "@mui/material";
import { invoiceOptions } from "./constants";
import { useEffect, useState } from "react";
import AlertDialog from "Components/AlertDialog/AlertDialog";

export default function CustomizeDriverInvoice(props) {
  const { handleClose, updateDriverInvoiceSettings } = props;
  const [driverInvoiceSettings, setDriverInvoiceSettings] = useState(undefined);
  const [openUpdateSettings, setOpenUpdateSettings] = useState(false);

  useEffect(() => {
    setDriverInvoiceSettings(props?.driverInvoiceSettings);
  }, [props]);

  return (
    <div>
      <Typography variant="h5">Driver Invoice Settings</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <Select
                  fullWidth
                  size="small"
                  sx={{ mt: 1, width: 200 }}
                  value={driverInvoiceSettings?.firstOption ?? ""}
                  onChange={(e) => {
                    setDriverInvoiceSettings((pre) => ({
                      ...pre,
                      firstOption: e?.target?.value,
                    }));
                  }}
                >
                  {invoiceOptions?.map((e) => (
                    <MenuItem key={e?.key} value={e?.key}>
                      {e?.name}
                    </MenuItem>
                  ))}
                </Select>
              </TableCell>
              <TableCell>
                <Select
                  fullWidth
                  size="small"
                  sx={{ mt: 1, width: 200 }}
                  value={driverInvoiceSettings?.secondOption ?? ""}
                  onChange={(e) => {
                    setDriverInvoiceSettings((pre) => ({
                      ...pre,
                      secondOption: e?.target?.value,
                    }));
                  }}
                >
                  {invoiceOptions?.map((e) => (
                    <MenuItem key={e?.key} value={e?.key}>
                      {e?.name}
                    </MenuItem>
                  ))}
                </Select>
              </TableCell>
              <TableCell>
                <Select
                  fullWidth
                  size="small"
                  sx={{ mt: 1, width: 200 }}
                  value={driverInvoiceSettings?.thirdOption ?? ""}
                  onChange={(e) => {
                    setDriverInvoiceSettings((pre) => ({
                      ...pre,
                      thirdOption: e?.target?.value,
                    }));
                  }}
                >
                  {invoiceOptions?.map((e) => (
                    <MenuItem key={e?.key} value={e?.key}>
                      {e?.name}
                    </MenuItem>
                  ))}
                </Select>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <br />
      <div>
        <Button
          variant="contained"
          onClick={() => {
            setOpenUpdateSettings(true);
          }}
          style={{ marginRight: 10 }}
          size="small"
        >
          Save & Close
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            handleClose();
          }}
          size="small"
          color="error"
        >
          Close
        </Button>
      </div>
      <AlertDialog
        open={openUpdateSettings}
        handleClose={() => {
          setOpenUpdateSettings(false);
        }}
        handleConfirm={async () => {
          await updateDriverInvoiceSettings(driverInvoiceSettings);
          setOpenUpdateSettings(false);
        }}
        dialogTitle={`Confirm Update Customer Invoice Setttings?`}
      />
    </div>
  );
}
